import script from "./DeleteEmployee.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeleteEmployee.vue?vue&type=script&setup=true&lang=ts"

import "./DeleteEmployee.vue?vue&type=style&index=0&id=901a4d6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-901a4d6e"]])

export default __exports__